import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/apps/blog/src/components/PageLayout/PageLayout.tsx";
import { graphql } from 'gatsby';
import { Container, PageOffset, HobbiesList } from 'components';
export const HobbiesIndexQuery = graphql`
    query HobbiesIndexQuery {
        allMdx(
            sort: { fields: [frontmatter___sort], order: DESC }
            filter: { frontmatter: { published: { eq: true }, kind: { eq: "Hobbies" } } }
        ) {
            edges {
                node {
                    id
                    frontmatter {
                        title
                        description
                        date
                        slug
                        images {
                            image {
                                childImageSharp {
                                    gatsbyImageData(
                                        layout: CONSTRAINED
                                        width: 3000
                                        quality: 80
                                        placeholder: BLURRED
                                    )
                                }
                            }
                            isCover
                        }
                    }
                }
            }
        }
    }
`;
export const _frontmatter = {};
const layoutProps = {
  HobbiesIndexQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Container mdxType="Container">
      <HobbiesList data={props.data.allMdx.edges} mdxType="HobbiesList" />
    </Container>
    <PageOffset mdxType="PageOffset" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      